import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -30%);
  z-index: 99999999999999999;
`;
